import { keymirror } from 'utils/keymirror'

export const COMPLIANCE_TAB = 'compliance'
export const SHIPMENTS_TAB = 'shipments'
export const TRAILERS_TAB = 'trailers'
export const USERS_TAB = 'users'
export const MATCHING_SHIPMENTS_TAB = 'matching_shipments'
export const LOGS_TAB = 'logs'

export const CARRIER_PROFILE_TABS = keymirror({
  [COMPLIANCE_TAB]: undefined,
  [SHIPMENTS_TAB]: undefined,
  [TRAILERS_TAB]: undefined,
  [USERS_TAB]: undefined,
  [MATCHING_SHIPMENTS_TAB]: undefined,
  [LOGS_TAB]: undefined,
}) as { [key: string]: string }

export const DELIVERY_OPTIONS = [
  { name: 'Deliver any day', key: 'any_day', altKey: 'any' },
  { name: 'Same day', key: 'same_day', altKey: 'same-day' },
  { name: 'Next day', key: 'next_day', altKey: 'next-day' },
]

export const DEFAULT_PER_PAGE = 50

export const DEFAULT_SHIPMENT_FILTERS = {
  filters: {
    usersType: 'carrier',
    status: [
      'covered',
      'offered',
      'assigned',
      'dispatched',
      'arrived_for_pickup',
      'in_transit',
      'arrived_for_delivery',
      'delivered',
      'documents_received',
      'pod_rejected',
      'invoice_sent',
      'completed',
    ],
  },
  sortField: 'pickups',
  sortOrder: 'desc',
  perPage: DEFAULT_PER_PAGE,
  pageCount: 0,
}

export const DEFAULT_USERS_FILTERS = {
  sortField: 'created_at',
  perPage: DEFAULT_PER_PAGE,
  pageCount: 0,
}

export const ELD_STATUS = {
  eld: 'This carrier is live in p44 (ELD)',
  api: 'This carrier is live in p44 (API)',
  mobile: 'This carrier is live in p44 (mobile)',
}
